import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, bindResource, rpcCrudService, addOnInvalidateHandler, invalidateResource } from "kea-resource";
import { CampoRepetidoIdentificacion, ResourceIdentificacionRepetido } from "./identificacion";

const controller = rpcController("MatrizTarifa");
const crud = rpcCrudService<models.MatrizTarifa, models.MatrizTarifaDTO>(controller);

const otros = cacheResource({
    add: crud.add,
    query: crud.query,
    delete: crud.delete,
    update: crud.update,
    get: crud.get,
    getMemo: crud.getMemo,

    /**
    * Duplica una mmatriz de tarifa existente, agrega la entidad y devuelve la nueva entidad.
    * Devuelve el Id de la nueva factura
    */
    DuplicarMatriz: async (id: number): Promise<number> => await controller("DuplicarMatriz", { id }),

    ActualizarPreciosMatriz: async (cantidad: number,seguro: number, aumento: boolean , IdMatrizTarifa: number | null ): 
    Promise<void> => await controller("ActualizarPreciosMatriz", {cantidad,aumento,seguro, IdMatrizTarifa}),

    //public async Task ActualizarPreciosMatriz(decimal cantidad , bool aumento)


}, {
        query: true,
        get: true
    }, {
        DuplicarMatriz: true
    });


export const MatrizTarifa = bindResource({ ...otros }); 


// WEBPACK FOOTER //
// ./app/resources/items/matriztarifa.tsx